export { RoundedChip } from './styled'
